"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = exports.DenseSelect = exports.GroupedSelect = exports.Select = exports.Currency = exports.Outlined = exports.Date = exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _react = require("@emotion/react");

var _core = require("@material-ui/core");

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _DateRangeOutlined = _interopRequireDefault(require("@material-ui/icons/DateRangeOutlined"));

var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _pickers = require("@material-ui/pickers");

var _fearless = require("@zip/react-icons/fearless");

var _propTypes = require("prop-types");

var _react2 = require("react");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _ = require("../../..");

var css = _interopRequireWildcard(require("./TextField.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Basic = function Basic(_ref) {
  var endIcon = _ref.endIcon,
      startIcon = _ref.startIcon,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["endIcon", "startIcon", "value"]);

  return (0, _jsxRuntime.jsx)(_TextField["default"], _objectSpread({
    css: css.textField,
    InputProps: {
      startAdornment: startIcon && (0, _jsxRuntime.jsx)(_InputAdornment["default"], {
        position: "start",
        children: startIcon
      }),
      endAdornment: endIcon && (0, _jsxRuntime.jsx)(_InputAdornment["default"], {
        position: "end",
        children: endIcon
      })
    },
    variant: "outlined",
    value: value || ''
  }, props));
};

exports.Basic = Basic;

var Date = function Date(props) {
  return (0, _jsxRuntime.jsx)(_pickers.MuiPickersUtilsProvider, {
    utils: _moment["default"],
    children: (0, _jsxRuntime.jsx)(_pickers.KeyboardDatePicker, _objectSpread(_objectSpread({
      css: css.textField,
      disableToolbar: true,
      format: "DD/MM/YYYY",
      inputVariant: "outlined",
      keyboardIcon: (0, _jsxRuntime.jsx)(_DateRangeOutlined["default"], {
        css: css.calendarIcon
      })
    }, props), {}, {
      okLabel: "Save"
    }))
  });
};

exports.Date = Date;

var Outlined = function Outlined(_ref2) {
  var error = _ref2.error,
      props = _objectWithoutProperties(_ref2, ["error"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    endIcon: error && (0, _jsxRuntime.jsx)(_ErrorOutline["default"], {
      css: css.errorIcon
    }),
    error: error
  }, props));
};

exports.Outlined = Outlined;

var NumberFormatCustom = function NumberFormatCustom(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, ["inputRef", "onChange"]);

  return (0, _jsxRuntime.jsx)(_reactNumberFormat["default"], _objectSpread(_objectSpread({}, other), {}, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore https://mui.com/components/text-fields/#integration-with-3rd-party-input-libraries
        target: {
          // eslint-disable-next-line react/destructuring-assignment
          name: props.name,
          value: values.value
        }
      });
    },
    decimalScale: 2,
    fixedDecimalScale: true,
    thousandSeparator: true,
    isNumericString: true,
    prefix: "$"
  }));
};

var Currency = function Currency(_ref3) {
  var endIcon = _ref3.endIcon,
      startIcon = _ref3.startIcon,
      value = _ref3.value,
      error = _ref3.error,
      props = _objectWithoutProperties(_ref3, ["endIcon", "startIcon", "value", "error"]);

  return (0, _jsxRuntime.jsx)(_TextField["default"], _objectSpread({
    css: css.textField,
    InputProps: {
      startAdornment: startIcon && (0, _jsxRuntime.jsx)(_InputAdornment["default"], {
        position: "start",
        children: startIcon
      }),
      endAdornment: endIcon && (0, _jsxRuntime.jsx)(_InputAdornment["default"], {
        position: "end",
        children: endIcon
      }),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore https://github.com/s-yadav/react-number-format/issues/244
      inputComponent: NumberFormatCustom
    },
    variant: "outlined",
    value: value || '',
    error: error
  }, props));
};

exports.Currency = Currency;

var Select = function Select(_ref4) {
  var onChange = _ref4.onChange,
      options = _ref4.options,
      value = _ref4.value,
      props = _objectWithoutProperties(_ref4, ["onChange", "options", "value"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread(_objectSpread({
    SelectProps: {
      IconComponent: _KeyboardArrowDown["default"],
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        MenuListProps: {
          disablePadding: true
        }
      },
      value: value
    },
    onChange: onChange,
    select: true
  }, props), {}, {
    children: options.map(function (option) {
      return (0, _jsxRuntime.jsxs)(_MenuItem["default"], {
        value: option.value,
        css: css.menuItem(value === option.value),
        children: [option.label, (0, _jsxRuntime.jsx)(_.Icons.Done, {
          size: 20,
          title: "Tick",
          fill: theme.colors.primary.medium
        })]
      }, option.value);
    })
  }));
};

exports.Select = Select;
Select.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.exact)({
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  }).isRequired).isRequired
};

var GroupedSelect = function GroupedSelect(_ref5) {
  var _onChange = _ref5.onChange,
      options = _ref5.options,
      value = _ref5.value,
      props = _objectWithoutProperties(_ref5, ["onChange", "options", "value"]);

  var theme = (0, _react.useTheme)();

  var _useState = (0, _react2.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      optionsToDisplay = _useState2[0],
      setOptionsToDisplay = _useState2[1];

  (0, _react2.useEffect)(function () {
    var newOptions = [];
    Object.keys(options).forEach(function (group) {
      newOptions.push({
        label: group,
        value: "##".concat(group)
      });
      options[group].forEach(function (option) {
        return newOptions.push(option);
      });
    });
    setOptionsToDisplay(newOptions);
  }, [options]);
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread(_objectSpread({
    SelectProps: {
      IconComponent: _KeyboardArrowDown["default"],
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        MenuListProps: {
          disablePadding: true
        }
      },
      value: value
    },
    onChange: function onChange(e) {
      var _e$target;

      if (!(e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.value)) {
        return;
      }

      _onChange(e);
    },
    select: true
  }, props), {}, {
    children: optionsToDisplay.map(function (option) {
      var isGroupTitle = option.value.includes('##');
      return isGroupTitle ? (0, _jsxRuntime.jsx)(_ListSubheader["default"], {
        children: option.label
      }) : (0, _jsxRuntime.jsxs)(_MenuItem["default"], {
        value: option.value,
        css: css.menuItem(value === option.value),
        children: [option.label, (0, _jsxRuntime.jsx)(_.Icons.Done, {
          size: 20,
          title: "Tick",
          fill: theme.colors.primary.medium
        })]
      }, option.value);
    })
  }));
};

exports.GroupedSelect = GroupedSelect;
var useStyles = (0, _core.makeStyles)({
  textFieldRoot: {
    '& > div::before, & > div::after, &:hover > div:not(.Mui-disabled)::before, &:hover > div::after': {
      borderBottom: 'unset'
    }
  },
  icon: {
    // Hard coded as theme.colors.navy causes errors here
    color: '#21285E'
  }
});

var DenseSelect = function DenseSelect(_ref6) {
  var options = _ref6.options,
      placeholder = _ref6.placeholder,
      value = _ref6.value,
      _ref6$label = _ref6.label,
      label = _ref6$label === void 0 ? '' : _ref6$label,
      props = _objectWithoutProperties(_ref6, ["options", "placeholder", "value", "label"]);

  var classes = useStyles();
  var theme = (0, _react.useTheme)();

  var _useState3 = (0, _react2.useState)(value || 'none'),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1]; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var handleChange = function handleChange(event) {
    setSelectedOption(event.target.value);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (0, _jsxRuntime.jsxs)(_TextField["default"], _objectSpread(_objectSpread({
    SelectProps: {
      IconComponent: _ArrowDropDown["default"],
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        MenuListProps: {
          disablePadding: true,
          style: {
            maxWidth: 320
          }
        }
      },
      classes: {
        icon: classes.icon
      },
      value: options.length > 0 ? selectedOption : 'none',
      onChange: function onChange(event) {
        handleChange(event);
      }
    },
    select: true,
    classes: {
      root: classes.textFieldRoot
    },
    label: label,
    css: css.textField
  }, props), {}, {
    children: [placeholder && (0, _jsxRuntime.jsxs)(_MenuItem["default"], {
      value: "none",
      css: css.denseMenuItem(selectedOption === 'none'),
      disabled: true,
      children: [(0, _jsxRuntime.jsx)("span", {
        children: placeholder
      }), (0, _jsxRuntime.jsx)(_.Icons.Done, {
        size: 20,
        title: "Tick",
        fill: theme.colors.primary.medium
      })]
    }), options.map(function (option) {
      return (0, _jsxRuntime.jsxs)(_MenuItem["default"], {
        value: option.value,
        css: css.denseMenuItem(selectedOption === option.value),
        children: [(0, _jsxRuntime.jsx)("span", {
          children: option.label
        }), (0, _jsxRuntime.jsx)(_.Icons.Done, {
          size: 20,
          title: "Tick",
          fill: theme.colors.primary.medium
        })]
      }, option.value);
    })]
  }));
};

exports.DenseSelect = DenseSelect;

var Search = function Search(props) {
  return (0, _jsxRuntime.jsx)(_Autocomplete["default"], _objectSpread(_objectSpread({
    freeSolo: true
  }, props), {}, {
    renderInput: function renderInput(params) {
      return (0, _jsxRuntime.jsx)(Outlined, _objectSpread(_objectSpread({}, params), {}, {
        variant: "outlined" // eslint-disable-next-line react/destructuring-assignment
        ,
        placeholder: props.placeholder,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_InputAdornment["default"], {
              position: "start",
              children: (0, _jsxRuntime.jsx)(_fearless.Search, {})
            }), params.InputProps.startAdornment]
          })
        })
      }));
    }
  }));
};

exports.Search = Search;
DenseSelect.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.exact)({
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  }).isRequired).isRequired,
  placeholder: _propTypes.string,
  label: _propTypes.string
};
DenseSelect.defaultProps = {
  placeholder: null,
  label: null
};